import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AbstractApiGuardService } from '../abstract.api-guard.service';
import { ApplicantModel } from '../../../shared/models/states/applicant.model';
import { MessageResponse } from '../auth.api.service';

@Injectable({
    providedIn: 'root',
})
export class NonjointApplicantService extends AbstractApiGuardService {
    private readonly apiUrl = `${environment.apiVersionString}/nonjoint_applicants`;

    // Create an application
    // createNonjointApplicant(application: ApplicantModel, loanId: string): Observable<ApplicantModel> {
    //     return this.post<ApplicantModel>(`${this.apiUrl}/${loanId}`, application).pipe(map(setApplicantType));
    // }

    // Read all applications
    // getLoanApplicants(): Observable<ApplicantModel[]> {
    //   return this.get(this.apiUrl);
    // }

    getNonjointApplicantsByLoanId(loan_application_uuid: string): Observable<ApplicantModel[]> {
        return this.get<ApplicantModel[]>(`${this.apiUrl}/loan_application_id/${loan_application_uuid}`).pipe(map(setApplicantTypes));
    }

    getOrCreateNonjointApplicant(applicant: ApplicantModel, loanId: string): Observable<ApplicantModel> {
        return this.post<ApplicantModel>(`${this.apiUrl}/${loanId}`, applicant).pipe(map(setApplicantType));
    }

    // Read a single application by ID
    getNonjointApplicantById(id: string): Observable<ApplicantModel> {
        return this.get<ApplicantModel>(`${this.apiUrl}/applicant_id/${id}`).pipe(map(setApplicantType));
    }

    // Update an application
    updateNonjointApplicant(id: string, application: ApplicantModel): Observable<ApplicantModel> {
        return this.put<ApplicantModel>(`${this.apiUrl}/${id}`, application).pipe(map(setApplicantType));
    }

    // Delete an application
    deleteNonjointApplicant(id: string): Observable<void> {
        return this.delete(`${this.apiUrl}/${id}`);
    }

    acceptInvite(token: string): Observable<MessageResponse> {
        return this.post<MessageResponse>(`${this.apiUrl}/invite/accept`, { token });
    }
}

function setApplicantType(a: ApplicantModel): ApplicantModel {
    return {
        ...a,
        applicant_type: "Nonjoint"
    }
}

function setApplicantTypes(a: ApplicantModel[]): ApplicantModel[] {
    return a.map(setApplicantType);
}
